import { TableDataRes } from 'components/table/base/tableBaseApi';
import { ValidationSectionId, ValidationTableDef, ValidationDetail } from 'models/validation';
import { useGetValidationRequest } from 'pages/validation/network/validationRequest';

interface CountHelperProps {
    setIsFetching: (value: boolean) => void;  
    setCountFromResponse: (value: number | null, id: ValidationSectionId) => void;
    globalSearch: string | null;
}

export default function CountHelper(props: CountHelperProps) {

    const filters ='{"currencies":0,"match_same_exchange":true,"amount_accuracy":90,"time_accuracy":2}';

    const {
      data: data1,
    } = useGetValidationRequest(
      "validationDuplicateTable",
      "/reports/tax/validation/duplicates",
        props.setIsFetching,
        [{id: "status", value: 3}], 
        props.globalSearch, 
        0, 
        10,
        [], 
        filters,
        (response: TableDataRes<ValidationTableDef, ValidationDetail> | null) => {
          if (response) {
            props.setCountFromResponse(response.meta.total_item_count, ValidationSectionId.DUPLICATE);
          } else {
            props.setCountFromResponse(null, ValidationSectionId.DUPLICATE);
          }
      },
      true,
    )

    const {
      data: data2,
    } = useGetValidationRequest(
        "validationFlowNegativesTable",
        "/reports/tax/validation/transaction-flow",
        props.setIsFetching,
        [], 
        props.globalSearch, 
        0, 
        10, 
        [], 
        filters,
        (response: TableDataRes<ValidationTableDef, ValidationDetail> | null) => {
          if (response) {
            props.setCountFromResponse(response.meta.total_item_count, ValidationSectionId.NEGATIVE);
          } else {
            props.setCountFromResponse(null, ValidationSectionId.NEGATIVE);
          }
      },
      data1 != undefined,
    )

  const {
    data: data3,
  } = useGetValidationRequest(
      "validationNoticeTable",
      "/reports/tax/validation/validate",
      props.setIsFetching,
      [{id: "status", value: 5}], 
      props.globalSearch, 
      0, 
      10, 
      [], 
      filters,
      (response: TableDataRes<ValidationTableDef, ValidationDetail> | null) => {
        if (response) {
            props.setCountFromResponse(response.meta.total_item_count, ValidationSectionId.NOTICE);
          } else {
            props.setCountFromResponse(null, ValidationSectionId.NOTICE);
          }
    },
    data2 != undefined,
  )

    const {
    data: data4,
  } = useGetValidationRequest(
      "validationWarningTable",
      "/reports/tax/validation/validate",
      props.setIsFetching,
      [{id: "status", value: 4}], 
      props.globalSearch, 
      0, 
      10, 
      [], 
      filters,
      (response: TableDataRes<ValidationTableDef, ValidationDetail> | null) => {
        if (response) {
            props.setCountFromResponse(response.meta.total_item_count, ValidationSectionId.WARNING);
          } else {
            props.setCountFromResponse(null, ValidationSectionId.WARNING);
          }
    },
    data3 != undefined,
  )

  return null
}